/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetMainPageBrandBannerEnrichmentsRequest,
  TGetMainPageBrandBannerEnrichmentsModel,
  IMappers,
  TGetMainPageBrandBannerEnrichmentsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1GetMainPageBrandBannerEnrichmentsResponse } from '../../entities/get_main_page_brand_banner_enrichments_v1/V1GetMainPageBrandBannerEnrichmentsResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetMainPageBrandBannerEnrichmentsModel(
  parameters: IGetMainPageBrandBannerEnrichmentsRequest,
): TGetMainPageBrandBannerEnrichmentsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'ad-banner',
    pathApi: '/v1/get-main-page-brand-banner-enrichments/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetMainPageBrandBannerEnrichmentsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMainPageBrandBannerEnrichmentsRequest;
}

export async function fetchGetMainPageBrandBannerEnrichments<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMainPageBrandBannerEnrichmentsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetMainPageBrandBannerEnrichmentsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetMainPageBrandBannerEnrichmentsModel(parameters),
    config,
  )) as FetchResponse<TGetMainPageBrandBannerEnrichmentsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1GetMainPageBrandBannerEnrichmentsResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetMainPageBrandBannerEnrichmentsResponse>;
}
